/**
 * Navigation state keys for `/teammates?tab=channels`.
 *
 * Pass via `navigate('/teammates?tab=channels', { [KEY]: true })` — see `helpers/history.navigate`.
 */

/** Auto-open the Shopify connect sub-wizard on the Channels tab. */
export const START_CONNECT_SHOPIFY_STATE_KEY = 'startConnectShopify';

/** Query param set when returning from Shopify App Store install / OAuth. */
export const SHOPIFY_CONNECT_RETURN_QUERY_PARAM = 'shopifyConnected';

/** Query param: arrived at Channels from Toriut setup wizard Step 3 (connect sales channel). */
export const FROM_SETUP_QUERY_PARAM = 'fromSetup';

/** sessionStorage: keep from-setup intent across tab switches until store connect or sample data. */
export const FROM_SETUP_STORAGE_KEY = 'channelsFromSetupWizard';

/** sessionStorage flag: Shopify wizard import in progress (suppress global pull-complete Toast). */
export const SHOPIFY_WIZARD_STEP6_SESSION_KEY = 'shopifyWizardStep6Active';

/** sessionStorage: pending channel id after successful Explore products (skip wizard auto-resume). */
export const SHOPIFY_WIZARD_COMPLETED_SESSION_KEY = 'shopifyWizardCompletedChannelId';

/** Query param: connected channel sub-view on the Channels tab. */
export const CHANNEL_SUB_VIEW_QUERY_PARAM = 'channelSubView';

/** Query param: sales channel id for connected channel sub-views. */
export const CHANNEL_ID_QUERY_PARAM = 'channelId';

export const CHANNEL_SUB_VIEW_SYNC_SETTINGS = 'sync-settings';
export const CHANNEL_SUB_VIEW_MAPPING_FIELDS = 'mapping-fields';

/** sessionStorage: sales channel id while reconnect OAuth is in progress. */
export const CHANNEL_RECONNECT_PENDING_SESSION_KEY = 'channelReconnectPending';
